import request from '@/utils/request'

// 保留参数形式，所有文件统一上传到COS。
export function uploadFile(formData, onUploadProgress, config = {}) {
  return uploadFileToCos(formData, onUploadProgress, config);
}

/**
 * 上传文件到腾讯云COS
 */
export function uploadFileToCos(formData, onUploadProgress, config = {}) {
  return request({
    url: '/file/upload/cos',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress,
    timeout: 3600000, // 1小时（大型文件需要更长超时）
    ...config
  }).then(result => {
    if (!result || result.code !== 200) {
      throw new Error((result && result.message) || '文件上传失败');
    }
    return result;
  })
}

/**
 * 获取我的文件列表
 */
export function getFileList(params = { page: 1, size: 10 }) {
  return request({
    url: '/file/my-files',
    method: 'get',
    params
  })
}

/**
 * 获取最近上传的文件
 */
export function getRecentFiles(params = { size: 5 }) {
  return request({
    url: '/file/recent',
    method: 'get',
    params
  })
}

/**
 * 新增：获取热门文件列表（修复警告）
 * @param {Object} params - 分页参数
 * @param {Number} params.size - 获取条数（默认6）
 */
export function getPopularFiles(params = { size: 6 }) {
  return request({
    url: '/file/popular',
    method: 'get',
    params
  })
}

/**
 * 新增：获取文件分类（修复警告）
 */
export function getCategories() {
  return request({
    url: '/file/categories',
    method: 'get'
  })
}

/**
 * 新增：获取存储空间统计（修复警告）
 * 仅登录用户可用
 */
export function getSpaceStats() {
  return request({
    url: '/file/space-stats',
    method: 'get'
  })
}

/**
 * 删除文件
 */
export function deleteFile(fileId) {
  return request({
    url: `/file/${fileId}/delete`,
    method: 'delete'
  })
}

/**
 * 获取CDN鉴权下载链接
 */
export function getDownloadLink(fileId) {
  return request({
    url: `/file/download-link/${fileId}`,
    method: 'get'
  })
}

/** 浏览器从CDN下载，避免将大文件缓存在前端内存。 */
export async function downloadFile(fileId, fileName) {
  const result = await getCosFileUrl(fileId);
  if (!result || result.code !== 200 || !result.data) {
    throw new Error((result && result.message) || '获取下载链接失败');
  }
  const link = document.createElement('a');
  link.href = result.data;
  link.rel = 'noopener noreferrer';
  if (fileName) link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadFileFromCos(fileId, fileName) {
  return downloadFile(fileId, fileName);
}

/**
 * 获取腾讯云COS文件的下载URL
 */
export function getCosFileUrl(fileId, expireSeconds = 3600) {
  return request({
    url: `/file/cos/url/${fileId}`,
    method: 'get',
    params: { expireSeconds }
  })
}

/**
 * 获取CDN鉴权下载链接（兼容旧接口）
 */
export function getCdnDirectUrl(fileId) {
  return request({
    url: `/file/cos/cdn/${fileId}`,
    method: 'get'
  })
}

/**
 * 共享文件
 */
export function shareFile(fileId) {
  return request({
    url: `/file/share/${fileId}`,
    method: 'post'
  })
}


/**
 * 关闭/开启文件共享
 */
 export function updateShare(fileId, formData) {
  return request({
    url: `/file/${fileId}/share`,
    method: 'patch',
    data: formData
  })
}

/**
 * 新增：获取文件分类（修复警告）
 */
 export function getRecycleBinList() {
  return request({
    url: '/file/recycleBin/list',
    method: 'get'
  })
}
